var map = {
	"./tutorial-normal-competitiveness-3.jpg": "4ymT",
	"./tutorial-tool-competitiveness-3.jpg": "J2nI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2CkK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/tutorial\-.*\-competitiveness\-3\.jpg$
// module id = 2CkK
// module chunks = 3